import * as React from "react";

function SvgLogoAcala(props) {
  return (
    <svg width={80} height={80} fill="none" viewBox="0 0 80 80" {...props}>
      <path
        fill="url(#logo-acala_svg__paint0_linear)"
        fillRule="evenodd"
        d="M39.9997 66.6663C54.7269 66.6663 66.6663 54.7269 66.6663 39.9997C66.6663 25.2725 54.7269 13.333 39.9997 13.333C25.2725 13.333 13.333 25.2725 13.333 39.9997C13.333 54.7269 25.2725 66.6663 39.9997 66.6663ZM40.1084 64.1637C53.4537 64.1637 64.2712 53.345 64.2712 40.0009C64.2712 26.6569 53.4537 15.8369 40.1084 15.8369C26.7633 15.8369 15.9458 26.6544 15.9458 39.9997C15.9458 53.3449 26.7633 64.1637 40.1084 64.1637ZM39.9997 62.3126C52.323 62.3126 62.3126 52.323 62.3126 39.9997C62.3126 27.6763 52.323 17.6868 39.9997 17.6868C27.6763 17.6868 17.6868 27.6763 17.6868 39.9997C17.6868 52.323 27.6763 62.3126 39.9997 62.3126ZM40.0547 59.5923C50.9047 59.5923 59.7011 50.7959 59.7011 39.9459C59.7011 29.0959 50.9047 20.2995 40.0547 20.2995C29.2047 20.2995 20.4083 29.0947 20.4083 39.9459C20.4083 50.7972 29.2034 59.5923 40.0547 59.5923ZM39.8897 43.623C38.7977 43.623 37.7372 43.7143 36.7102 43.8881L38.2912 41.1429C38.8252 41.1079 39.3593 41.0904 39.8897 41.0904C41.1316 41.0904 42.3948 41.1929 43.6155 41.3893L37.4769 30.7268L27.2573 48.4758L25.7965 45.9394L37.4531 25.6938L37.4769 25.7352L37.4995 25.6951L51.5676 50.128H48.6472L45.359 44.4172C43.6455 43.8994 41.8145 43.623 39.8897 43.623ZM52.4769 48.5183L38.8565 24.8634H41.7769L53.9365 45.9819L52.4769 48.5183ZM38.9591 36.534L33.367 46.247C35.3683 45.6416 37.7234 45.3715 39.9459 45.3715C40.1261 45.3715 40.3061 45.374 40.4862 45.3777C41.7481 45.4077 43.024 45.5416 44.2459 45.7705L46.1119 49.0112C44.202 48.3145 42.1347 47.9043 39.9459 47.9043C36.709 47.9043 33.7361 48.7072 31.147 50.103L31.1883 50.0293L31.132 50.1268H28.2116L37.4995 33.9962L38.9591 36.534Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id="logo-acala_svg__paint0_linear"
          x1={55.352}
          x2={24.169}
          y1={63.524}
          y2={15.742}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.008} stopColor="#645AFF" />
          <stop offset={0.504} stopColor="#E40C5B" />
          <stop offset={1} stopColor="#FF4C3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgLogoAcala;
